




import { Vue } from 'vue-property-decorator';

export default class Logout extends Vue {}
